import React, { useEffect, useState } from "react";
import MUIDataTable from "mui-datatables";
import { Container, Fab, Tooltip, Backdrop } from "@material-ui/core";
import { Link, useHistory, Route } from "react-router-dom";
import AddIcon from "@material-ui/icons/Add";
import CircularProgress from "@material-ui/core/CircularProgress";
import useStyles from "../../components/Common/styles";
import CaseCategoryManage from "./case.category.manage";
import CaseCategoryCreate from "./case.category.create";
import { useFetchCaseCategories } from "../../hooks/useFetchEntities";

function CaseCategories() {
  const history = useHistory();
  const classes = useStyles();
  const [caseCategories, fetched] = useFetchCaseCategories();
  const [loading, setLoading] = useState(false);

  const onRowClick = (rowData, rowMeta) => {
    history.push("/casecategories/manage/" + rowData[0]);
  };

  useEffect(() => {
    setLoading(!fetched);
  }, [fetched]);

  const gridOptions = {
    filterType: "multiselect",
    selectableRows: "none",
    rowsPerPage: 25,
    rowsPerPageOptions: [25, 50, 100],
    onRowClick: onRowClick,
    print: false,
    download: false,
    fixedHeader: true,
    tableBodyMaxHeight: "60vh",
  };

  const gridColumns = [
    {
      name: "id",
      label: "Id",
      options: {
        filter: false,
        sort: false,
        display: false,
        viewColumns: false,
      },
    },
    {
      name: "name",
      label: "Name",
      options: {
        filter: true,
        sort: true,
        display: true,
      },
    },
  ];

  const fabStyle = {
    right: 20,
    position: "fixed",
  };

  return (
    <div style={{ marginRight: 32 }}>
      <Tooltip title="Add" aria-label="add">
        <Fab color="primary" aria-label="add" style={fabStyle} component={Link} to={"/casecategories/create"}>
          <AddIcon />
        </Fab>
      </Tooltip>
      {!loading && (
        <MUIDataTable title={"Case Categories"} data={caseCategories} columns={gridColumns} options={gridOptions} />
      )}

      <Route exact path="/casecategories/manage/:caseCategoryId">
        <CaseCategoryManage />
      </Route>
      <Route path="/casecategories/create">
        <CaseCategoryCreate />
      </Route>
      <Backdrop className={classes.backdrop} open={loading}>
        <CircularProgress color="secondary" />
      </Backdrop>
    </div>
  );
}

export default CaseCategories;
